// extracted by mini-css-extract-plugin
module.exports = {"compact":"productCardCompact_compact__jY_Rh"};